<template>
  <div class="ETankstellenFilterContainer">
    <Header name="Filter E-Tankstellen" headerClasses="colorLightGreen" />
    <div class="ETankstellenFilterContent" style="margin-top:40px;">
      <div v-for="(filterKey, index) of Object.keys(layer.icons.filter)" :key="filterKey">
        <Select
          :selectOptions="getDataEntrysByKey(filterKey)"
          :placeholder="platzhalter[filterKey]"
          :icon="'icon_expand_more_green'"
          :border="{color:'borderLightGreen',top:index===0,bottom:true}"
          v-model="layer.icons.filter[filterKey]"
          @change="setLayerFilter(layer.id,filterKey,...arguments)"
        >
          <template slot="close">
            <SVGIcon
              name="close"
              size="little"
              class="selfAlignCenter"
              @click.native.stop="setLayerFilter(layer.id,filterKey,null)"
            />
          </template>
        </Select>
      </div>

      <div
        class="cursor-pointer backgroundLightGreen colorWhite displayflex flexcenter padding10 borderRadius30"
        style="margin-top:40px;"
        @click="resetLayerFilter"
      >
        <div class="selfAlignCenter">Filter zurücksetzen</div>
      </div>
    </div>
  </div>
</template>

<script>
import Select from "./../CoreComponents/Select.vue";
import Header from "./../CoreComponents/Header.vue"

export default {
  name: "ETankstellenFilter",
  components: { Select,Header },
  data: function() {
    return {
      platzhalter: {
        Betreiber_: "Verbund",
        Anzahl_Ladepunkte_: "Anzahl Ladepunkte",
        Art_des_Ladepunktes_: "Art des Ladepunktes",
        Nennleistung_Ladepunkt_1_: "Nennleistung des Ladepunktes"
      }
    };
  },
  computed: {
    device() {
      return this.$store.state.device;
    },
    layer() {
      return this.$store.state.layers.filter(layer => layer.id === 7)[0];
    },
    features() {
      return this.layer.icons.data.features;
    }
  },
  methods: {
    resetLayerFilter() {
      this.$store.commit("resetLayerFilter", { layerID: this.layer.id });
    },
    setLayerFilter(layerID, filterKey, value) {
      this.$store.commit("setLayerFilter", { layerID, filterKey, value });
    },
    closeSidebar() {
      this.$emit("close");
    },
    getDataEntrysByKey(key) {
      const obj = {};
      for (const feature of this.features) {
        if (feature.properties[key].trim() === "") continue;
        obj[feature.properties[key]] = "";
      }
      return Object.keys(obj).sort((a, b) =>
        a.localeCompare(b, "de", { numeric: true })
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ETankstellenFilterContainer {
  height: 100%;
  width: 100%;
  font-size: 18px;
}

.ETankstellenFilterContent {
  height: calc(100% - 62.4px);
  overflow-y: auto;
  font-size: 18px;
}

</style>
